// Module
var code = " <span ng-bind=\"$ctrl.getItemTypeText()\"></span> ";
// Exports
export default code;